module.exports = __webpack_public_path__ + "img/PK.9f9b75d9.png";